// assets
import { SettingOutlined, MailOutlined, ClockCircleOutlined } from '@ant-design/icons';

// icons
const icons = {
  SettingOutlined,
  MailOutlined,
  ClockCircleOutlined
};

// ==============================|| MENU ITEMS - SETTINGS ||============================== //

const settings = {
  id: 'group-settings',
  title: 'Settings',
  type: 'group',
  children: [
    {
      id: 'email-settings',
      title: 'Email Settings',
      type: 'item',
      url: '/settings/email',
      icon: icons.MailOutlined,
      description: 'Configure mail server, automated expiry notification schedules, and recipient distribution.'
    },
    {
      id: 'scheduler-management',
      title: 'Scheduler',
      type: 'item',
      url: '/settings/scheduler',
      icon: icons.ClockCircleOutlined,
      description: 'Manage license expiry verification, pending email queues, and automated cron jobs.'
    }
  ]
};

export default settings;
